import React, { useState } from "react";
import { Card, Table, Form,  } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";

import { Row, Col, Breadcrumb, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import AddFaqModal from "../components/modals/Faq/AddFaqModal";
import EditFaqModal from "../components/modals/Faq/EditFaqModal";
import DeleteModal from "../components/modals/Faq/DeleteModal";
const initialData = [
  {
    id: 1,
    question: "What is an HRMS?",
    answer:
      "Software system that automates and manages various human resources tasks",
    category: "General",
  },
  {
    id: 2,
    question: "How does an HRMS benefit organizations?",
    answer:
      "It enhances operational efficiency, reduces manual errors, and centralizes HR tasks",
    category: "General",
  },
  {
    id: 3,
    question: "Is the data stored in SilconAdmins secure?",
    answer:
      "Yes, SilconAdmins is designed with advanced security measures, including data encryption",
    category: "Feature",
  },
  {
    id: 4,
    question: "How do I add a new employee?",
    answer:
      "You can add a new employee by entering their personal details and creating a profile in the system",
    category: "Employee",
  },
  {
    id: 5,
    question: "How can I generate reports?",
    answer:
      "Reports can be generated from the reporting module by selecting filters and exporting the data",
    category: "Reports",
  },
  {
    id: 6,
    question: "How do I process payroll?",
    answer:
      "Payroll can be processed by reviewing employee attendance, deductions, and approving salary payments",
    category: "Payroll",
  },
  {
    id: 7,
    question: "Can I track employee attendance?",
    answer:
      "Yes, attendance can be tracked using the attendance management system",
    category: "Employee",
  },
  {
    id: 8,
    question: "How do I apply for leave?",
    answer:
      "Employees can apply for leave through the leave management section by selecting dates and submitting requests",
    category: "Leaves",
  },
  {
    id: 9,
    question: "How do I schedule training sessions?",
    answer:
      "Training sessions can be scheduled by creating events and assigning employees",
    category: "Training",
  },
  {
    id: 10,
    question: "Can I export reports?",
    answer:
      "Yes, reports can be exported in multiple formats such as PDF and Excel",
    category: "Reports",
  },
  {
    id: 11,
    question: "How do I update employee details?",
    answer:
      "Employee details can be updated from the employee profile section by editing required fields",
    category: "Employee",
  },
  {
    id: 12,
    question: "Is there role-based access control?",
    answer:
      "Yes, SilconAdmins supports role-based access to restrict or allow features based on user roles",
    category: "Security",
  },
  {
    id: 13,
    question: "How do I reset my password?",
    answer:
      "You can reset your password using the 'Forgot Password' option on the login page",
    category: "Account",
  },
  {
    id: 14,
    question: "Can I manage multiple departments?",
    answer:
      "Yes, departments can be created and managed under the organization settings",
    category: "Organization",
  },
  {
    id: 15,
    question: "Does the system support notifications?",
    answer:
      "Yes, the system provides notifications for important updates and actions",
    category: "Feature",
  },
];
const FaqPage = () => {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);

  const filtered = data
    .filter(
      (item) =>
        item.question.toLowerCase().includes(search.toLowerCase()) ||
        item.answer.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

  return (
    <>
     <div  
style={{ padding: "15px", background: "#f8f9fa",  }} >
          <div
      style={{
        
      
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Row className="align-items-center justify-content-between">
        
        {/* LEFT SIDE */}
        <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>FAQ</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Pages
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Faq</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT SIDE BUTTON */}
        <Col
          md={6}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
        <Button
  onClick={() => setShowModal(true)}
  style={{
    backgroundColor: "#f97316",
    border: "none",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "6px",
  }}
>
  Add New Faq
</Button>
        </Col>

      </Row>
    </div>
      <Card style={{ border: "1px solid #e5e7eb", borderRadius: "8px" }}>
        
        {/* HEADER */}
        <div
          style={{
            padding: "16px",
            borderBottom: "1px solid #e5e7eb",
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          FAQ List
        </div>

        {/* FILTER */}
        <div
          style={{
            padding: "12px 16px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            Row Per Page
            <Form.Select
              style={{ width: "70px" }}
              value={rows}
              onChange={(e) => setRows(Number(e.target.value))}
            >
              {[5, 10, 20].map((n) => (
                <option key={n}>{n}</option>
              ))}
            </Form.Select>
            Entries
          </div>

          <Form.Control
            placeholder="Search"
            style={{ width: "200px" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div style={{ overflowX: "auto" }}>
          <Table hover style={{ marginBottom: 0 }}>
            <thead style={{ background: "#f9fafb" }}>
              <tr>
                <th style={{ width: "40px" }}>
                  <Form.Check />
                </th>
                <th>Questions</th>
                <th>Answers</th>
                <th>Categories</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Form.Check />
                  </td>

                  <td style={{ fontWeight: 500 }}>
                    {item.question}
                  </td>

                  <td style={{ color: "#6b7280" }}>
                    {item.answer}
                  </td>

                  <td>{item.category}</td>

                  <td>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <FiEdit2
                        style={{ cursor: "pointer" }}
                        onClick={() => setEditItem(item)}
                      />
                      <FiTrash2
                        style={{ cursor: "pointer" }}
                        onClick={() => setDeleteItem(item)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>
<AddFaqModal
  show={showModal}
  handleClose={() => setShowModal(false)}
/>
      {/* MODALS */}
      {editItem && (
        <EditFaqModal
          show={true}
          data={editItem}
          handleClose={() => setEditItem(null)}
          handleSave={(updated) => {
            setData((prev) =>
              prev.map((i) => (i.id === updated.id ? updated : i))
            );
            setEditItem(null);
          }}
        />
      )}

      {deleteItem && (
        <DeleteModal
          show={true}
          handleClose={() => setDeleteItem(null)}
          handleDelete={() => {
            setData((prev) =>
              prev.filter((i) => i.id !== deleteItem.id)
            );
            setDeleteItem(null);
          }}
        />
      )}
     </div>
    </>
  );
};

export default FaqPage;